import { Injectable } from '@angular/core';
import { finalize } from 'rxjs';
import { FormsApiService } from '@tangilla/tg-ng-core';
import { NrdsUtilsService } from 'src/app/core/services/utils/nrds.utils.service';
import { ErrorsService } from '../../core/services/utils/errors.service';
import { FormJsonService } from '../../core/services/survey/form-json.service';
import { TangillaFormsConfigService } from './tangilla-forms-config.service';
import { TokensService } from '../../core/services/auth/tokens.service';

@Injectable({
  providedIn: 'root'
})
export class TangillaFormsService {
  isLoadingForm = false;
  isLoadingModelConfiguration = false;

  formJsonLoaded = false;

  constructor(private nrdsUtilsService: NrdsUtilsService,
              private formsApiService: FormsApiService,
              private errorsService: ErrorsService,
              private formJsonService: FormJsonService,
              private tangillaFormsConfigService: TangillaFormsConfigService,
              private tokensService: TokensService) {
  }

  processFormId(formId: string, params: any) {
    this.isLoadingForm = true;

    this.formsApiService.getFormJson(formId, {params})
      .pipe(finalize(() => this.isLoadingForm = false))
      .subscribe({
        next: async data => {
          await this.processForm(data);
        },
        error: error => this.errorsService.processError(error)
      });
  }

  private async processForm(formData: any) {
    this.isLoadingModelConfiguration = true;
    this.formJsonService.tgForm = formData;
    this.tangillaFormsConfigService.setApplicationConfig(formData.application_config);
    this.tokensService.tokens = formData.form_tokens;

    if (formData.uses_nrds) {
      const nrdsIsAvailable = await this.nrdsUtilsService.checkNrdsService();
      if (!nrdsIsAvailable) {
        this.isLoadingModelConfiguration = false;
        this.formJsonLoaded = true;
        return;
      }
    }

    this.isLoadingModelConfiguration = false;
    this.formJsonLoaded = true;
  }

  isItLoading() {
    return this.isLoadingForm || this.isLoadingModelConfiguration;
  }
}
